$ = jQuery = require('jquery');
module.exports = require('./dist/jquery-ui.js');